import { createStore } from 'vuex'
import { getToken, clearToken, setToken ,setStorage, getStorage, removeStorage} from '@/utils'
import md5 from 'js-md5'
import { userLogin, userLogout, getUserPersonal } from '@/api/index'

export default createStore({
  state: {
    // menuTreeMetaVos: [],
  },
  getters: {
    // menuTreeMetaVos: state => state.menuTreeMetaVos,
  },
  mutations: {
    // setMenuTreeMetaVos(state, menuTreeMetaVos) {
    //   state.menuTreeMetaVos = menuTreeMetaVos
    // },
    clearState(state) {
      clearToken() 
      removeStorage("menuTreeMetaVos")
      removeStorage("permissions")
      removeStorage("webUserVo")
    }
  },
  actions: {
    // 登录
    handleLogin({ commit }, { username, password }) {
      return new Promise((resolve, reject) => {
        userLogin({
          name: username,
          password: md5(password)
        }).then(res => {
          const token = res.data.sessionId
          setToken(token)
          resolve(res)
        }).catch(err => {
          commit('clearState')
          reject(err)
        })
      })
    },
    // 获取用户信息
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserPersonal().then(res => {
          // commit('setMenuTreeMetaVos', res.data.menuTreeMetaVos)
          setStorage("menuTreeMetaVos", res.data.menuTreeMetaVos)
          setStorage("permissions", res.data.permissions)
          setStorage("webUserVo", res.data.webUserVo)
          resolve(res)
        }).catch(err => {
          commit('clearState')
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut({ commit }) {
      return new Promise((resolve, reject) => {
        userLogout().then(() => {
          commit('clearState')
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
  },
  modules: {
  }
})
